/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApproveTimeEntriesRequest
 */
export interface ApproveTimeEntriesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApproveTimeEntriesRequest
     */
    ids: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof ApproveTimeEntriesRequest
     */
    approvalDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ApproveTimeEntriesRequest
     */
    note?: string | null;
}

/**
 * Check if a given object implements the ApproveTimeEntriesRequest interface.
 */
export function instanceOfApproveTimeEntriesRequest(value: object): value is ApproveTimeEntriesRequest {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('approvalDate' in value) || value['approvalDate'] === undefined) return false;
    return true;
}

export function ApproveTimeEntriesRequestFromJSON(json: any): ApproveTimeEntriesRequest {
    return ApproveTimeEntriesRequestFromJSONTyped(json, false);
}

export function ApproveTimeEntriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApproveTimeEntriesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'approvalDate': (new Date(json['approvalDate'])),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function ApproveTimeEntriesRequestToJSON(json: any): ApproveTimeEntriesRequest {
    return ApproveTimeEntriesRequestToJSONTyped(json, false);
}

export function ApproveTimeEntriesRequestToJSONTyped(value?: ApproveTimeEntriesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
        'approvalDate': value['approvalDate'].toISOString().substring(0,10),
        'note': value['note'],
    };
}

